import styled from 'styled-components';

export const ChangePasswordView = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  padding: 20px 0;
  background: #ffffff;
`;

export const ChangePasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
